export default [
  {
    question: "Com que frequência você usa a máscara??",
    answer1: "Sempre",
    answer2: "Quase sempre",
    answer3: "Freqüentemente",
    answer4: "As vezes",
    answer5: "Quase nunca",
    answer6: "Nunca",
    img: "/images/survey/mascarilla.svg",
    advice: "Use sempre máscara.",
    inverted: true,
  },
  {
    question: "Com que frequência você lava as mãos?",
    answer1: "Sempre",
    answer2: "Quase sempre",
    answer3: "Freqüentemente",
    answer4: "As vezes",
    answer5: "Quase nunca",
    answer6: "Nunca",
    img: "/images/survey/lavado-manos.svg",
    advice: "Lave frequentemente as mãos.",
    inverted: true,
  },
  {
    question:
      "Quantas horas por semana você fica fora de casa em espaços abertos?",
    answer1: "Mais que 50",
    answer2: "40 a 50",
    answer3: "30 a 40",
    answer4: "20 a 30",
    answer5: "10 a 20",
    answer6: "0 a 10",
    img: "/images/survey/espacios-abiertos.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Quantas horas por semana você fica fora de casa em espaços fechados?",
    answer1: "Mais que 50",
    answer2: "40 a 50",
    answer3: "30 a 40",
    answer4: "20 a 30",
    answer5: "10 a 20",
    answer6: "0 a 10",
    img: "/images/survey/espacios-cerrados.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "Quantas vezes você toca seu rosto?",
    answer1: "Sempre",
    answer2: "Quase sempre",
    answer3: "Freqüentemente",
    answer4: "As vezes",
    answer5: "Quase nunca",
    answer6: "Nunca",
    img: "/images/survey/tocar-cara.svg",
    advice: "Evite tocar no seu rosto.",
    inverted: false,
  },
  {
    question: "Quantas pessoas vivem em sua casa, além de você?",
    answer1: "5 ou mais",
    answer2: "4",
    answer3: "3",
    answer4: "2",
    answer5: "1",
    answer6: "0",
    img: "/images/survey/habitantes-casa.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Você mantém a distância social recomendada com o resto das pessoas?",
    answer1: "Sempre",
    answer2: "Quase sempre",
    answer3: "Freqüentemente",
    answer4: "As vezes",
    answer5: "Quase nunca",
    answer6: "Nunca",
    img: "/images/survey/distanciamiento.svg",
    advice: "Mantenha a distância recomendada com as outras pessoas.",
    inverted: true,
  },
  {
    question: "Você usa dinheiro?",
    answer1: "Sempre",
    answer2: "Quase sempre",
    answer3: "Freqüentemente",
    answer4: "As vezes",
    answer5: "Quase nunca",
    answer6: "Nunca",
    img: "/images/survey/dinero.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "Quantos minutos por semana você usa o elevador da comunidade?",
    answer1: "Nunca",
    answer2: "0 a 2",
    answer3: "2 a 5",
    answer4: "5 a 10",
    answer5: "10 a 20",
    answer6: "Mais que 20",
    img: "/images/survey/ascensor.svg",
    advice:
      "Evite usar os elevadores. Sempre que possível, use as escadas, o que também lhe permitirá fazer exercício físico.",
    inverted: true,
  },
  {
    question: "Quantas horas por semana você usa o transporte público?",
    answer1: "Mais que 25",
    answer2: "20 a 25",
    answer3: "15 a 20",
    answer4: "10 a 15",
    answer5: "5 a 10",
    answer6: "0 a 5",
    img: "/images/survey/transporte-publico.svg",
    advice: "",
    inverted: false,
  },
];
